import * as React from "react";

function SvgComponent({
  backgroundColor,
  ...others
}: React.SVGProps<SVGSVGElement> & { backgroundColor?: string }) {
  return (
    <svg
      width={268.199}
      height={189.509}
      viewBox="0 0 268.199 189.509"
      {...others}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 10"
            d="M561.5 836.026l-2.856-92.133a4.56 4.56 0 014.709-4.393h145.854a4.56 4.56 0 014.71 4.393l-4.285 92.133a4.559 4.559 0 01-4.709 4.393H566.206a4.56 4.56 0 01-4.706-4.393z"
            transform="translate(-558.64 -739.5)"
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Path 11"
            d="M1017.5 855.584q.272 31.926-.6 38.918l2.213 40.931h43.242q1.984-44.911 1.983-48.337t.14-31.421l-12.042-4.3-17.054-.213z"
            transform="translate(-1016.9 -851.16)"
          />
        </clipPath>
      </defs>
      <g data-name="&lt;Group&gt;">
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M172.15 577.456q-17.642-15.553-41.02-67.173c-23.378-51.621-14.479-112.4 27.534-118.247q42.013-5.844 74.637 19.04 46.86-14.97 84.265-4.732t33.723 60.409q23.587 13.931 33.212 45.584t-23.487 64.984z"
            transform="translate(-118.47 -390.925) translate(118.47 390.925) translate(-118.47 -390.925)"
            fill={backgroundColor ?? "#fff"}
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M599.3 1661.615H379.552a2.2 2.2 0 01-2.2-2.2v-.061a2.2 2.2 0 012.2-2.2H599.3a2.2 2.2 0 012.2 2.2v.061a2.2 2.2 0 01-2.2 2.2z"
            transform="translate(-118.47 -390.925) translate(156.303 575.969) translate(-377.35 -1657.15)"
            fill="#7c9af2"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M673.13 814.991H523a4.56 4.56 0 01-4.71-4.393l-2.86-102.785a4.559 4.559 0 014.709-4.393h157.276a4.56 4.56 0 014.709 4.393L677.84 810.6a4.56 4.56 0 01-4.71 4.391z"
            transform="translate(-118.47 -390.925) translate(176.482 436.592) translate(-515.43 -703.42)"
            fill="#eae9f3"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M701.606 709.7a4.156 4.156 0 01.792 2.438l-4.283 102.785a4.56 4.56 0 01-4.71 4.393H543.269a4.9 4.9 0 01-2.879-.918 4.8 4.8 0 003.918 1.955h150.134a4.56 4.56 0 004.71-4.393l4.283-102.785a4.289 4.289 0 00-1.829-3.475z"
            transform="translate(-118.47 -390.925) translate(180.129 437.51) translate(-540.39 -709.7)"
            fill="#4951ec"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M562.957 820.558l-2.857-92.134a4.56 4.56 0 014.71-4.394h145.858a4.559 4.559 0 014.709 4.394l-4.283 92.133a4.56 4.56 0 01-4.71 4.393H567.666a4.559 4.559 0 01-4.709-4.392z"
            transform="translate(-118.47 -390.925) translate(183.01 439.604) translate(-560.1 -724.03)"
            fill="#7c9af2"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <g
            data-name="&lt;Clip Group&gt;"
            clipPath="url(#a)"
            fill="#92b5f9"
            transform="translate(-118.47 -390.925) translate(182.796 441.865)"
          >
            <path
              data-name="&lt;Path&gt;"
              d="M1584.71 1428.046l5.328-.346v.346z"
              transform="translate(-1434.761 -1327.127)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1495.77 1423.111l18.326-1.191v.845l-5.328.346z"
              transform="translate(-1358.819 -1322.192)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1406.83 1418.176l31.323-2.036v.845l-18.326 1.191z"
              transform="translate(-1282.876 -1317.257)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1317.89 1413.249l44.321-2.879v.843l-31.323 2.036z"
              transform="translate(-1206.934 -1312.33)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1228.95 1408.314l57.319-3.724v.845l-44.321 2.879z"
              transform="translate(-1130.992 -1307.395)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1140.02 1403.378l70.315-4.568v.845l-57.319 3.724z"
              transform="translate(-1055.058 -1302.459)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1051.08 1398.443l83.312-5.413v.845l-70.315 4.568z"
              transform="translate(-979.115 -1297.524)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M962.14 1393.508l96.31-6.258v.845l-83.312 5.413z"
              transform="translate(-903.173 -1292.589)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M873.2 1388.572l109.307-7.1v.845l-96.31 6.258z"
              transform="translate(-827.231 -1287.653)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M784.26 1383.637l122.305-7.947v.845l-109.307 7.1z"
              transform="translate(-751.288 -1282.718)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M695.32 1378.7l135.3-8.792v.845l-122.3 7.947z"
              transform="translate(-675.346 -1277.783)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M606.38 1373.766l148.3-9.636v.845l-135.3 8.792z"
              transform="translate(-599.403 -1272.847)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M576.837 1368.831l-.037-.564 152.623-9.917v.845l-148.3 9.636z"
              transform="translate(-574.146 -1267.912)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M576.484 1363.332l-.054-.84 152.677-9.921v.845z"
              transform="translate(-573.83 -1262.977)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M576.106 1357.556l-.056-.84 152.733-9.926v.845z"
              transform="translate(-573.506 -1258.041)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M575.734 1351.78l-.054-.842 152.787-9.929v.845z"
              transform="translate(-573.19 -1253.106)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M575.364 1346l-.054-.84 152.841-9.933v.845z"
              transform="translate(-572.874 -1248.171)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M574.986 1340.228l-.056-.842 152.9-9.936v.845z"
              transform="translate(-572.549 -1243.235)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M574.614 1334.451l-.054-.842 152.95-9.939v.845z"
              transform="translate(-572.234 -1238.3)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M574.236 1328.674l-.056-.84 153.006-9.943v.845z"
              transform="translate(-571.909 -1233.365)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M573.864 1322.9l-.054-.842 153.06-9.946v.845z"
              transform="translate(-571.593 -1228.43)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M573.494 1317.129l-.054-.84 153.114-9.949v.843z"
              transform="translate(-571.277 -1223.503)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M573.116 1311.345l-.056-.842 153.17-9.953v.846z"
              transform="translate(-570.953 -1218.559)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M572.744 1305.577l-.054-.84 153.224-9.957v.843z"
              transform="translate(-570.637 -1213.632)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M572.366 1299.8l-.056-.842L725.589 1289v.845z"
              transform="translate(-570.312 -1208.697)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M571.994 1294.024l-.054-.84 153.333-9.964v.845z"
              transform="translate(-569.996 -1203.761)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M571.624 1288.248l-.054-.842 153.387-9.967v.845z"
              transform="translate(-569.68 -1198.826)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M571.246 1282.471l-.056-.84 153.443-9.971v.845z"
              transform="translate(-569.356 -1193.891)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M570.874 1276.7l-.054-.842 153.5-9.974v.845z"
              transform="translate(-569.04 -1188.955)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M570.5 1270.919l-.056-.84 153.552-9.979v.845z"
              transform="translate(-568.716 -1184.02)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M570.124 1265.143l-.054-.842 153.607-9.981v.845z"
              transform="translate(-568.4 -1179.085)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M569.754 1259.366l-.054-.84 153.661-9.986v.845z"
              transform="translate(-568.084 -1174.15)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M569.376 1253.59l-.056-.842 153.716-9.989v.845z"
              transform="translate(-567.759 -1169.214)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M569 1247.813l-.054-.84 153.77-9.993v.845z"
              transform="translate(-567.443 -1164.279)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M568.626 1242.038l-.056-.842 153.826-10v.845z"
              transform="translate(-567.119 -1159.344)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M568.254 1236.261l-.054-.84 153.88-10v.845z"
              transform="translate(-566.803 -1154.408)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M567.884 1230.485l-.054-.842 153.934-10v.845z"
              transform="translate(-566.487 -1149.473)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M567.506 1224.708l-.056-.84 153.99-10.008v.845z"
              transform="translate(-566.163 -1144.538)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M567.134 1218.932l-.054-.842 154.043-10.011v.845z"
              transform="translate(-565.847 -1139.602)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M566.756 1213.155l-.056-.84 154.1-10.015v.845z"
              transform="translate(-565.522 -1134.667)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M566.384 1207.38l-.054-.842 154.153-10.018v.845z"
              transform="translate(-565.206 -1129.732)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M566.014 1201.6l-.054-.842 154.207-10.021v.845z"
              transform="translate(-564.89 -1124.796)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M565.636 1195.825l-.056-.84 154.263-10.025v.845z"
              transform="translate(-564.566 -1119.861)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M565.264 1190.058l-.054-.842 154.317-10.027v.843z"
              transform="translate(-564.25 -1114.934)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M564.886 1184.281l-.056-.84 154.37-10.031v.845z"
              transform="translate(-563.925 -1109.999)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M564.514 1178.506l-.054-.842 154.426-10.034v.845z"
              transform="translate(-563.61 -1105.064)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M564.144 1172.729l-.054-.84 154.48-10.038v.845z"
              transform="translate(-563.294 -1100.128)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M563.766 1166.953l-.056-.842 154.536-10.041v.845z"
              transform="translate(-562.969 -1095.193)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M563.394 1161.176l-.054-.84 154.59-10.046v.845z"
              transform="translate(-562.653 -1090.258)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M563.016 1155.4l-.056-.842 154.646-10.048v.845z"
              transform="translate(-562.329 -1085.322)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M562.644 1149.623l-.054-.84 154.7-10.053v.845z"
              transform="translate(-562.013 -1080.387)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M562.274 1143.848l-.054-.842 154.754-10.056v.845z"
              transform="translate(-561.697 -1075.452)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M561.9 1138.071l-.056-.84 154.809-10.06v.845z"
              transform="translate(-561.372 -1070.516)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M561.524 1132.295l-.054-.842 154.863-10.063v.845z"
              transform="translate(-561.056 -1065.581)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M561.146 1126.518l-.056-.84 154.919-10.068v.845z"
              transform="translate(-560.732 -1060.646)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M560.774 1120.742l-.054-.842 154.973-10.07v.845z"
              transform="translate(-560.416 -1055.71)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M560.4 1114.965l-.054-.84 155.027-10.075v.845z"
              transform="translate(-560.1 -1050.775)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M560.026 1109.19l-.056-.842 155.083-10.078v.845z"
              transform="translate(-559.776 -1045.84)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M559.654 1103.412l-.054-.84 155.137-10.082v.845z"
              transform="translate(-559.46 -1040.904)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M559.276 1097.637l-.056-.842 155.192-10.085v.845z"
              transform="translate(-559.135 -1035.969)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.9 1091.86l-.054-.84 155.254-10.09v.845z"
              transform="translate(-558.819 -1031.034)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.671 1086.084l-.031-.476v-.367l155.277-10.091v.845z"
              transform="translate(-558.64 -1026.099)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1079.469l155.277-10.089v.843l-155.277 10.091z"
              transform="translate(-558.64 -1021.172)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1073.689l155.277-10.089v.845l-155.277 10.089z"
              transform="translate(-558.64 -1016.236)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1067.909l155.277-10.089v.845l-155.277 10.09z"
              transform="translate(-558.64 -1011.301)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1062.13l155.277-10.089v.845l-155.277 10.088z"
              transform="translate(-558.64 -1006.366)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1056.349l155.277-10.089v.845l-155.277 10.089z"
              transform="translate(-558.64 -1001.43)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1050.569l155.277-10.089v.845l-155.277 10.089z"
              transform="translate(-558.64 -996.495)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1044.789l155.277-10.089v.845l-155.277 10.089z"
              transform="translate(-558.64 -991.56)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1039.01l155.277-10.089v.845l-155.277 10.088z"
              transform="translate(-558.64 -986.625)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1033.231l155.277-10.091v.845l-155.277 10.09z"
              transform="translate(-558.64 -981.689)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1027.451l155.277-10.091v.845L558.64 1028.3z"
              transform="translate(-558.64 -976.754)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1021.671l155.277-10.091v.845l-155.277 10.091z"
              transform="translate(-558.64 -971.819)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1015.891l155.277-10.091v.845l-155.277 10.091z"
              transform="translate(-558.64 -966.883)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1010.111l155.277-10.091v.845l-155.277 10.091z"
              transform="translate(-558.64 -961.948)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 1004.331l155.277-10.091v.845l-155.277 10.091z"
              transform="translate(-558.64 -957.013)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 998.551l155.277-10.091v.845L558.64 999.4z"
              transform="translate(-558.64 -952.077)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 992.771l155.277-10.091v.845L558.64 993.616z"
              transform="translate(-558.64 -947.142)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 986.991L713.917 976.9v.845L558.64 987.836z"
              transform="translate(-558.64 -942.207)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 981.211l155.277-10.091v.845L558.64 982.056z"
              transform="translate(-558.64 -937.271)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 975.431l155.277-10.091v.845L558.64 976.276z"
              transform="translate(-558.64 -932.336)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 969.659l155.277-10.089v.843L558.64 970.5z"
              transform="translate(-558.64 -927.409)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 963.88l155.277-10.09v.845L558.64 964.724z"
              transform="translate(-558.64 -922.474)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 958.1l155.277-10.09v.845L558.64 958.944z"
              transform="translate(-558.64 -917.539)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 952.319l155.277-10.089v.845L558.64 953.164z"
              transform="translate(-558.64 -912.603)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 946.54l155.277-10.09v.845L558.64 947.384z"
              transform="translate(-558.64 -907.668)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 940.76l155.277-10.09v.845L558.64 941.6z"
              transform="translate(-558.64 -902.733)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 934.979l155.277-10.089v.845L558.64 935.824z"
              transform="translate(-558.64 -897.797)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 929.2l155.277-10.09v.845L558.64 930.044z"
              transform="translate(-558.64 -892.862)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 923.421l155.277-10.091v.845L558.64 924.264z"
              transform="translate(-558.64 -887.927)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 917.641l155.277-10.091v.845L558.64 918.486z"
              transform="translate(-558.64 -882.991)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 911.861l155.277-10.091v.845L558.64 912.706z"
              transform="translate(-558.64 -878.056)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 906.081l155.277-10.091v.845L558.64 906.926z"
              transform="translate(-558.64 -873.121)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 900.3l155.277-10.09v.845L558.64 901.146z"
              transform="translate(-558.64 -868.185)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 894.521l155.277-10.091v.845L558.64 895.366z"
              transform="translate(-558.64 -863.25)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 888.741l155.277-10.091v.845L558.64 889.586z"
              transform="translate(-558.64 -858.315)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 882.961l155.277-10.091v.845L558.64 883.806z"
              transform="translate(-558.64 -853.379)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 877.181l155.277-10.091v.845L558.64 878.026z"
              transform="translate(-558.64 -848.444)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 871.4l155.277-10.09v.845L558.64 872.246z"
              transform="translate(-558.64 -843.509)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 865.621l155.277-10.091v.845L558.64 866.466z"
              transform="translate(-558.64 -838.574)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 859.849l155.277-10.089v.843L558.64 860.694z"
              transform="translate(-558.64 -833.647)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 854.069l155.277-10.089v.845L558.64 854.914z"
              transform="translate(-558.64 -828.711)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 848.289L713.917 838.2v.845L558.64 849.134z"
              transform="translate(-558.64 -823.776)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 842.509l155.277-10.089v.845L558.64 843.354z"
              transform="translate(-558.64 -818.841)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 836.729l155.277-10.089v.845L558.64 837.574z"
              transform="translate(-558.64 -813.905)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 830.949l155.277-10.089v.845L558.64 831.794z"
              transform="translate(-558.64 -808.97)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 825.17l155.277-10.09v.845L558.64 826.014z"
              transform="translate(-558.64 -804.035)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 819.39l155.277-10.09v.845L558.64 820.234z"
              transform="translate(-558.64 -799.1)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 813.611l155.277-10.091v.845L558.64 814.454z"
              transform="translate(-558.64 -794.164)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 807.831l155.277-10.091v.845L558.64 808.676z"
              transform="translate(-558.64 -789.229)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 802.051l155.277-10.091v.845L558.64 802.9z"
              transform="translate(-558.64 -784.294)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 796.271l155.277-10.091v.845L558.64 797.116z"
              transform="translate(-558.64 -779.358)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 790.491L713.917 780.4v.845L558.64 791.336z"
              transform="translate(-558.64 -774.423)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 784.711l155.277-10.091v.845L558.64 785.556z"
              transform="translate(-558.64 -769.488)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 778.931l155.277-10.091v.845L558.64 779.776z"
              transform="translate(-558.64 -764.552)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 773.151l155.277-10.091v.845L558.64 774z"
              transform="translate(-558.64 -759.617)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 767.371l155.277-10.091v.845L558.64 768.216z"
              transform="translate(-558.64 -754.682)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 761.591L713.917 751.5v.845L558.64 762.436z"
              transform="translate(-558.64 -749.746)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 755.811l155.277-10.091v.845L558.64 756.656z"
              transform="translate(-558.64 -744.811)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 750.031l155.277-10.091v.845L558.64 750.876z"
              transform="translate(-558.64 -739.876)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 748.81l143.291-9.31h11.986v.064L558.64 749.655z"
              transform="translate(-558.64 -739.5)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 747.966l130.293-8.466h13l-143.293 9.31z"
              transform="translate(-558.64 -739.5)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 747.121l117.3-7.621h13l-130.3 8.466z"
              transform="translate(-558.64 -739.5)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M558.64 746.276l104.3-6.776h13l-117.3 7.621zM662.938 739.5l-104.3 6.776V739.5z"
              transform="translate(-558.64 -739.5)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M561.5 836.026l-2.856-92.133a4.56 4.56 0 014.709-4.393h145.854a4.56 4.56 0 014.71 4.393l-4.285 92.133a4.559 4.559 0 01-4.709 4.393H566.206a4.56 4.56 0 01-4.706-4.393z"
              transform="translate(-558.64 -739.5)"
            />
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Compound Path&gt;"
            d="M736.861 867.369h-2.628a.142.142 0 110-.285h2.354l.038-.8a.139.139 0 01.149-.136.142.142 0 01.136.149zm-6.053 0h-3.426a.142.142 0 110-.285h3.426a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.425a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.849 0h-3.425a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.425a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.425a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.425a.142.142 0 010-.285h3.425a.142.142 0 110 .285zm-6.849 0h-3.425a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.426a.142.142 0 010-.285h3.426a.142.142 0 110 .285zm-6.85 0h-3.425a.142.142 0 110-.285h3.421a.142.142 0 010 .285zm-6.851 0h-3.423a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.426a.142.142 0 110-.285h3.423a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.426a.142.142 0 110-.285h3.424a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.425a.142.142 0 110-.285h3.424a.142.142 0 010 .285zm-6.851 0h-.878l-.111-3.561a.143.143 0 01.285-.01l.1 3.287h.6a.142.142 0 110 .285zm136.275-4.353h-.006a.143.143 0 01-.136-.149l.159-3.423a.141.141 0 01.149-.136.144.144 0 01.136.149l-.159 3.423a.144.144 0 01-.141.136zM599.7 860.523a.145.145 0 01-.143-.139l-.105-3.424a.141.141 0 01.137-.146.142.142 0 01.148.137l.107 3.424a.144.144 0 01-.139.148zm137.546-4.351h-.007a.141.141 0 01-.135-.149l.158-3.421a.143.143 0 11.285.013l-.158 3.421a.144.144 0 01-.144.136zm-137.758-2.5a.142.142 0 01-.143-.137l-.105-3.424a.142.142 0 01.137-.148.145.145 0 01.148.139l.105 3.424a.14.14 0 01-.137.146zm138.076-4.345h-.007a.142.142 0 01-.136-.149l.159-3.421a.143.143 0 11.285.013l-.159 3.421a.142.142 0 01-.142.139zm-138.29-2.5a.143.143 0 01-.142-.139l-.107-3.423a.144.144 0 01.139-.148.149.149 0 01.148.139l.105 3.423a.142.142 0 01-.137.148zm138.607-4.342h-.006a.141.141 0 01-.136-.149l.159-3.421a.137.137 0 01.149-.136.141.141 0 01.136.149l-.159 3.421a.142.142 0 01-.143.137zm-138.819-2.5a.142.142 0 01-.142-.139l-.107-3.423a.144.144 0 01.139-.148.137.137 0 01.146.137l.107 3.424a.143.143 0 01-.139.148zm139.138-4.341h-.007a.142.142 0 01-.134-.149l.158-3.421a.143.143 0 11.285.013l-.158 3.421a.144.144 0 01-.144.136zm-139.35-2.509a.142.142 0 01-.142-.139l-.107-3.424a.141.141 0 01.139-.146.138.138 0 01.146.137l.107 3.424a.144.144 0 01-.139.148zm139.668-4.335h-.007a.143.143 0 01-.136-.149l.159-3.421a.143.143 0 11.285.013l-.159 3.421a.142.142 0 01-.142.136zm-139.88-2.515a.142.142 0 01-.143-.137l-.105-3.424a.142.142 0 01.137-.148.14.14 0 01.148.139l.105 3.424a.14.14 0 01-.137.146zm140.2-4.329h-.007a.142.142 0 01-.136-.149l.159-3.421a.14.14 0 01.149-.136.141.141 0 01.136.149l-.159 3.421a.143.143 0 01-.143.138zm-140.41-2.518a.143.143 0 01-.143-.137l-.107-3.424a.143.143 0 01.286-.009l.105 3.423a.142.142 0 01-.137.148zm140.727-4.324h-.006a.144.144 0 01-.136-.151l.159-3.421a.149.149 0 01.149-.136.143.143 0 01.136.149l-.159 3.423a.143.143 0 01-.144.138zm-140.941-2.522a.142.142 0 01-.142-.139l-.107-3.423a.145.145 0 01.139-.148.137.137 0 01.146.137l.107 3.424a.143.143 0 01-.139.148zm141.259-4.321h-.006a.141.141 0 01-.136-.149l.158-3.421a.143.143 0 11.285.013l-.158 3.421a.144.144 0 01-.144.137zM598 805.745a.141.141 0 01-.142-.137l-.107-3.424a.141.141 0 01.139-.146.143.143 0 01.146.137l.107 3.424a.142.142 0 01-.139.146zm141.79-4.315h-.007a.144.144 0 01-.136-.149l.159-3.423a.143.143 0 01.285.013l-.159 3.423a.142.142 0 01-.141.136zm-142-2.531a.142.142 0 01-.143-.137l-.105-3.424a.142.142 0 01.137-.148.145.145 0 01.148.139l.107 3.424a.142.142 0 01-.139.146zm142.32-4.313h-.01a.141.141 0 01-.136-.149l.159-3.421a.143.143 0 01.285.013l-.159 3.421a.141.141 0 01-.139.136zm-142.532-2.534a.143.143 0 01-.143-.139l-.105-3.423a.142.142 0 01.137-.148.139.139 0 01.148.139l.105 3.423a.142.142 0 01-.137.148zm142.849-4.308h-.006a.143.143 0 01-.136-.149l.159-3.423a.138.138 0 01.149-.134.142.142 0 01.136.149l-.159 3.421a.143.143 0 01-.143.136zm-143.063-2.538a.143.143 0 01-.142-.139l-.107-3.423a.144.144 0 01.139-.148.14.14 0 01.146.137l.107 3.424a.143.143 0 01-.137.148zm143.381-4.306h-.007a.141.141 0 01-.135-.149l.133-2.886h-.236a.142.142 0 110-.285h.536l-.148 3.184a.143.143 0 01-.143.136zm-143.593-2.541a.142.142 0 01-.142-.139l-.021-.64h3.079a.142.142 0 110 .285h-2.784l.01.346a.143.143 0 01-.139.148zm139.922-.494h-3.426a.142.142 0 010-.285h3.426a.142.142 0 110 .285zm-6.849 0H726.8a.142.142 0 110-.285h3.426a.142.142 0 010 .285zm-6.851 0h-3.425a.142.142 0 010-.285h3.425a.142.142 0 110 .285zm-6.849 0H713.1a.142.142 0 110-.285h3.426a.142.142 0 010 .285zm-6.851 0h-3.426a.142.142 0 010-.285h3.426a.142.142 0 110 .285zm-6.85 0H699.4a.142.142 0 110-.285h3.426a.142.142 0 010 .285zm-6.851 0h-3.426a.142.142 0 010-.285h3.426a.142.142 0 110 .285zm-6.85 0H685.7a.142.142 0 110-.285h3.425a.142.142 0 010 .285zm-6.851 0h-3.426a.142.142 0 010-.285h3.426a.142.142 0 110 .285zm-6.85 0H672a.142.142 0 110-.285h3.426a.142.142 0 010 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0H658.3a.142.142 0 110-.285h3.425a.142.142 0 110 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0h-3.42a.142.142 0 110-.285h3.425a.142.142 0 110 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.849 0h-3.42a.142.142 0 110-.285h3.425a.142.142 0 110 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.85 0H617.2a.142.142 0 110-.285h3.425a.142.142 0 110 .285zm-6.851 0h-3.424a.142.142 0 110-.285h3.424a.142.142 0 110 .285zm-6.849 0h-3.426a.142.142 0 110-.285h3.426a.142.142 0 110 .285z"
            transform="translate(-118.47 -390.925) translate(188.401 447.43) translate(-596.99 -777.58)"
            fill="#dde8fe"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <g
            data-name="&lt;Clip Group&gt;"
            clipPath="url(#b)"
            fill="#bed1f9"
            transform="translate(-118.47 -390.925) translate(249.766 458.183)"
          >
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1421.48l43.837.927H1016.9z"
              transform="translate(-1016.9 -1338.134)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1408.87l46.82.989-.038 1.78h-2.945l-43.837-.926z"
              transform="translate(-1016.9 -1327.367)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1396.26l46.858.99-.038 1.843-46.82-.989z"
              transform="translate(-1016.9 -1316.6)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1383.64l46.9.991-.039 1.843-46.858-.989z"
              transform="translate(-1016.9 -1305.824)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1371.03l46.937.992-.04 1.841-46.9-.991z"
              transform="translate(-1016.9 -1295.057)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1358.42l46.975.992-.038 1.843-46.937-.992z"
              transform="translate(-1016.9 -1284.29)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1345.81l47.014.994-.039 1.842-46.975-.992z"
              transform="translate(-1016.9 -1273.522)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1333.2l47.054.994-.039 1.843-47.014-.994z"
              transform="translate(-1016.9 -1262.755)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1320.59l47.092.994-.038 1.843-47.054-.994z"
              transform="translate(-1016.9 -1251.988)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1307.97l47.131 1-.039 1.841-47.092-.994z"
              transform="translate(-1016.9 -1241.212)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1295.36l47.171 1-.04 1.843-47.131-1z"
              transform="translate(-1016.9 -1230.445)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1282.75l47.209 1-.038 1.843-47.171-1z"
              transform="translate(-1016.9 -1219.678)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1270.13l47.248 1-.04 1.843-47.209-1z"
              transform="translate(-1016.9 -1208.902)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1257.52l47.286 1-.038 1.842-47.248-1z"
              transform="translate(-1016.9 -1198.135)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1244.91l47.326 1-.039 1.843-47.286-1z"
              transform="translate(-1016.9 -1187.368)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1232.3l47.365 1-.04 1.841-47.326-1z"
              transform="translate(-1016.9 -1176.601)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1219.69l47.4 1-.038 1.843-47.365-1z"
              transform="translate(-1016.9 -1165.833)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1207.07l47.443 1-.039 1.843-47.4-1z"
              transform="translate(-1016.9 -1155.058)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1194.46l47.482 1-.04 1.841-47.443-1z"
              transform="translate(-1016.9 -1144.291)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1181.85l47.52 1-.038 1.843-47.482-1z"
              transform="translate(-1016.9 -1133.523)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1169.24l47.559 1-.04 1.843-47.52-1z"
              transform="translate(-1016.9 -1122.756)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1156.63l47.578 1v.96l-.019.883-47.559-1z"
              transform="translate(-1016.9 -1111.989)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1144.01l47.578 1.005v1.843l-47.578-1z"
              transform="translate(-1016.9 -1101.213)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1131.4l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -1090.446)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1118.79l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -1079.679)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1106.18l47.578 1v1.844l-47.578-1.005z"
              transform="translate(-1016.9 -1068.912)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1093.56l47.578 1.005v1.843l-47.578-1z"
              transform="translate(-1016.9 -1058.136)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1080.95l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -1047.369)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1068.34l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -1036.602)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1055.73l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -1025.834)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1043.12l47.578 1v1.844l-47.578-1.005z"
              transform="translate(-1016.9 -1015.067)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1030.5l47.578 1.005v1.843l-47.578-1z"
              transform="translate(-1016.9 -1004.291)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1017.89l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -993.524)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 1005.28l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -982.757)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 992.67l47.578 1.005v1.843l-47.578-1.005z"
              transform="translate(-1016.9 -971.99)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.9 980.23v-.169l47.574 1v1.844L1016.9 981.9z"
              transform="translate(-1016.9 -961.223)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1016.93 969.293l.038-1.843 47.536 1v1.85z"
              transform="translate(-1016.926 -950.456)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1017.19 956.683l.039-1.843 47.5 1v1.843z"
              transform="translate(-1017.148 -939.688)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1017.46 944.081l.039-1.841 47.457 1v1.843z"
              transform="translate(-1017.378 -928.93)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1017.73 931.473l.038-1.843 47.419 1v1.844z"
              transform="translate(-1017.609 -918.162)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1017.99 918.863l.039-1.843 47.38 1v1.843z"
              transform="translate(-1017.831 -907.395)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1018.26 906.261l.038-1.841 47.342 1v1.843z"
              transform="translate(-1018.061 -896.637)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1018.52 893.653l.039-1.843 47.3 1v1.843z"
              transform="translate(-1018.283 -885.87)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1018.79 881.043l.039-1.843 47.263 1v1.843z"
              transform="translate(-1018.514 -875.102)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1019.06 868.441l.038-1.841 47.225 1v1.844z"
              transform="translate(-1018.744 -864.344)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1019.32 853.417l.048-2.256h47.177v3.253z"
              transform="translate(-1018.966 -851.16)"
            />
            <path
              data-name="&lt;Path&gt;"
              d="M1017.5 855.584q.272 31.926-.6 38.918l2.213 40.931h43.242q1.984-44.911 1.983-48.337t.14-31.421l-12.042-4.3-17.054-.213z"
              transform="translate(-1016.9 -851.16)"
            />
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1088.615 853.36l-8.535 2.389q3.417 17.061 5.457 19.1c2.039 2.039-.346 3.567 1.366 5.28q1.712 1.714 11.2 14.58z"
              transform="translate(-118.47 -390.925) translate(258.999 458.504) translate(-1080.08 -853.36)"
              fill="#92b5f9"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1212.135 857.18l-8.705 40.792q9.255-16.357 10.047-17.149c.792-.791 0-4.139 0-5.708q0-1.57 4.923-15.217-4.5-2.717-6.265-2.718z"
              transform="translate(-118.47 -390.925) translate(258.999 458.504) translate(18.026 .558) translate(-1203.43 -857.18)"
              fill="#92b5f9"
            />
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1090 851.16l-9.134.928q3.3 16.8 5.341 18.837c2.039 2.039-.346 3.569 1.366 5.28q1.712 1.714 11.2 16.626z"
              transform="translate(-118.47 -390.925) translate(259.114 458.183) translate(-1080.87 -851.16)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1211.707 852.62l-8.277 41.458q9.255-18.4 10.047-19.194c.792-.792 0-4.139 0-5.71q0-1.57 5.008-14.556-5.006-1.998-6.778-1.998z"
              transform="translate(-118.47 -390.925) translate(259.114 458.183) translate(17.911 .213) translate(-1203.43 -852.62)"
              fill="#dde8fe"
            />
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1195.12 1178.911l1.214-42.6-.25 42.6z"
            transform="translate(-118.47 -390.925) translate(275.811 499.854) translate(-1195.12 -1136.31)"
            fill="#92b5f9"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1036.258 1470.306h-32.538v-3.426h32.538z"
            transform="translate(-118.47 -390.925) translate(247.84 548.163) translate(-1003.72 -1466.88)"
            fill="#7c9af2"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1044.729 1506.138h-26.971l-.858-15.818h28.686z"
            transform="translate(-118.47 -390.925) translate(249.766 551.589) translate(-1016.9 -1490.32)"
            fill="#7c9af2"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1045.586 1490.32H1016.9l.858 15.818h3.547a18.457 18.457 0 012.375-7.188c2.405-3.8 14.275-5.3 21.757-5.867z"
            transform="translate(-118.47 -390.925) translate(249.766 551.589) translate(-1016.9 -1490.32)"
            fill="#4951ec"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M945.236 1607.122H871.88a8.563 8.563 0 018.564-8.562h56.228a8.563 8.563 0 018.564 8.562z"
            transform="translate(-118.47 -390.925) translate(228.573 567.407) translate(-871.88 -1598.56)"
            fill="#4951ec"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M753.945 838.542l-2.493-8.922-10.952 2.809q1.561 4.86 2.652 5.527l4.44 2.717 9.791 19.423 5.984-7.393z"
            transform="translate(-118.47 -390.925) translate(209.373 455.035) translate(-740.5 -829.62)"
            fill="#ef7f7f"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1145.439 735.954a40.149 40.149 0 010 8.421 9.613 9.613 0 01-2.069 4.638l8.777 41.671 8.277-41.458q-2.056-1.258-2.641-4.852a92.759 92.759 0 01-.571-12.844z"
            transform="translate(-118.47 -390.925) translate(268.248 440.7) translate(-1143.37 -731.53)"
            fill="#fb9390"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1156.528 722.91q-.048 20.169-.048 24.9c0 4.729 5.829 10.439 8.862 9.3q3.032-1.14 6.277-15.241l-.061-7.919z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(2.797 28.474) translate(-1156.48 -722.91)"
              fill="#fb9390"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1173.017 748.7v-7.447l-7.235-4.779a4.17 4.17 0 01-.415-.216 5.47 5.47 0 01-.805-.589l-6.364-4.2c0 .132 0 .316-.007.551 0 .025.006.045.007.059a23.823 23.823 0 003.374 11.342c2.287 3.503 7.444 6.062 11.445 5.279z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(3.047 29.725) translate(-1158.19 -731.47)"
              fill="#ef7f7f"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1161.612 568.475q-4.093 10.277-3.411 18.228c.682 7.95 11.712 18.348 16.6 15.168s3.3-12.233 3.3-14.311 1.86-11.622.249-15.047-13.668-7.341-16.738-4.038z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(3.035 5.723) translate(-1158.104 -567.227)"
              fill="#fb9390"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1165.006 529.778c-6.709-2.936-15.009-2.08-17.056 2.446q-2.045 4.527.462 23.976a22.822 22.822 0 003.632 10.521c2.842 4.036 10.12 6.728 14.1 3.792q3.979-2.935 2.733-12.362-.572 2.21-2.164 2.208c-1.592 0-1.9-1.2-2.616-1.344-2.62-.536-3.751.244-6.025 1.344a2.412 2.412 0 01-2.232-.281 6.722 6.722 0 01-3.155-6.528l.611-6.646a16.1 16.1 0 005.344-5.138c1.251 4.893 10.844 3.781 12.28 1.469s.794-10.521-5.914-13.457z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(1.417) translate(-1147.031 -528.066)"
              fill="#0b0754"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1169.446 576.076c-.845-1.794-4.552-3.722-8.334-4.676a8.845 8.845 0 00-.332 1.969l-5.263.785-7.837 5.432a100.061 100.061 0 0113.147-4.66 2.253 2.253 0 00.072.494 8.324 8.324 0 009.141 7.124c.146-2.563.077-5.044-.594-6.468z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(1.511 6.333) translate(-1147.68 -571.4)"
              fill="#ef7f7f"
              opacity={0.529}
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1163.264 558.31q-9.987 1.024-16.417 4.221a37.611 37.611 0 00.054 5.878c6.794-3.82 14.807-6.54 16.363-6.345a4.806 4.806 0 000-3.754z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(1.378 4.42) translate(-1146.767 -558.31)"
              fill="#92b5f9"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M1142.782 631.484q-1.366-4-4.245-3.1c-2.88.9.076 10.111 2.122 9.378s2.577-4.401 2.123-6.278z"
              transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(0 14.637) translate(-1137.338 -628.221)"
              fill="#fb9390"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <g data-name="&lt;Group&gt;">
              <path
                data-name="&lt;Path&gt;"
                d="M1255.906 535.505a8.036 8.036 0 11-9.353-7.094 8.311 8.311 0 019.353 7.094z"
                transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(14.998) translate(0 .035) translate(-1239.967 -528.303)"
                fill="#7c9af2"
              />
            </g>
            <g data-name="&lt;Group&gt;">
              <path
                data-name="&lt;Path&gt;"
                d="M1258.691 535.3c.8 4.668-1.98 9.039-6.212 9.765s-8.311-2.468-9.112-7.135 1.98-9.039 6.212-9.765 8.311 2.472 9.112 7.135z"
                transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(14.998) translate(.477) translate(-1243.23 -528.066)"
                fill="#bed1f9"
              />
            </g>
            <g data-name="&lt;Group&gt;">
              <path
                data-name="&lt;Path&gt;"
                d="M1247.827 535.9a8.868 8.868 0 011.982-7.374c-.076.01-.153.022-.229.035-4.232.726-7.013 5.1-6.212 9.765s4.881 7.861 9.112 7.134a7.263 7.263 0 004.231-2.391c-4.15.579-8.097-2.583-8.884-7.169z"
                transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(14.998) translate(.477 .068) translate(-1243.23 -528.53)"
                fill="#eae9f3"
              />
            </g>
            <g data-name="&lt;Group&gt;">
              <path
                data-name="&lt;Path&gt;"
                d="M1291.437 576.37a1.16 1.16 0 11-1.353-1.06 1.217 1.217 0 011.353 1.06z"
                transform="translate(-118.47 -390.925) translate(267.367 410.966) translate(14.998) translate(7.186 6.902) translate(-1289.141 -575.295)"
                fill="#92b5f9"
              />
            </g>
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1162.692 942.91l6.443-32.272a44.443 44.443 0 01-13.416-.829z"
            transform="translate(-118.47 -390.925) translate(270.053 466.754) translate(-1155.72 -909.81)"
            fill="#0b0754"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1169.136 910.639l-.137.015c-1.613 6.592-5.3 21.211-6.556 22.467-1.207 1.207-4.89-14.9-6.714-23.309h-.009l6.972 33.1z"
            transform="translate(-118.47 -390.925) translate(270.053 466.754) translate(-1155.72 -909.81)"
            fill="#0b0754"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Compound Path&gt;"
            d="M754.306 795.834c-.216.932-5.188 3.45-5.907 1.99a1.092 1.092 0 01.047-1.1 6.69 6.69 0 01-.266.187 3.415 3.415 0 01-2.11.682c-1.505-.152-2.923.361-4.324.332q-1.4-.028-1.292-5.365c.579-.947 4.653-1.708 6.179-2.075.177-.042.374-.1.583-.158a8.856 8.856 0 00-.855-1.428c-.642-.83-6.569-5.254-3.9-5.949 1.6-.482 9.709 7.232 9.806 7.352 1.145 1.415 2.254 4.598 2.039 5.532zm-3.012-3.974a.7.7 0 00-.206-.359 3.024 3.024 0 00-2.945.435c-.156 1.023.793 3.589.986 4.092a6.414 6.414 0 012-.9c.9-.215.399-2.296.165-3.268z"
            transform="translate(-118.47 -390.925) translate(209.365 448.212) translate(-740.446 -782.932)"
            fill="#fb9390"
            fillRule="evenodd"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M817.2 894.489q11.559 29.683 15.983 31.968t13.2-6.109q2.6-38.918.6-38.918c-2 0-4.746 8.986-7.11 14.862-2.4 5.979-2.449 12.641-5.679 6.832q-3.3-5.934-7.713-15a36.509 36.509 0 01-9.281 6.365z"
            transform="translate(-118.47 -390.925) translate(220.582 462.606) translate(-817.2 -881.43)"
            fill="#dde8fe"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M680.116 675.17a.536.536 0 01-.44-.84l20.334-29.466a.536.536 0 11.883.608l-20.335 29.467a.533.533 0 01-.442.231z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-622.135 -622.686)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M441.371 890.67a.531.531 0 01-.365-.145.538.538 0 01-.026-.758l33.752-36.082a.536.536 0 11.782.732L441.763 890.5a.531.531 0 01-.392.17z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-418.279 -801.043)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M513.706 740.895a.525.525 0 01-.311-.1l-27.147-19.458a.536.536 0 11.624-.871l27.147 19.458a.536.536 0 01-.313.972z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-456.864 -687.351)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M686.8 916.677a.538.538 0 01-.522-.414L671.8 854.171a.536.536 0 011.043-.243l14.477 62.092a.536.536 0 01-.4.644.592.592 0 01-.12.013z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-615.477 -801.042)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M646.256 821.958a6.028 6.028 0 11-6.028-6.028 6.029 6.029 0 016.028 6.028z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-583.386 -768.951)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M656.853 832.7a3.841 3.841 0 11-3.842-3.841 3.842 3.842 0 013.842 3.841z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-596.168 -779.991)"
            fill="#dde8fe"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M314.981 658.2h-25.7a2.789 2.789 0 01-2.79-2.79V633.8a2.789 2.789 0 012.79-2.79h25.7a2.789 2.789 0 012.79 2.79v21.61a2.79 2.79 0 01-2.79 2.79z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-286.49 -611.055)"
            fill="#bed1f9"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M317.9 632.98a2.783 2.783 0 01.288 1.236v21.611a2.789 2.789 0 01-2.79 2.79H289.7a2.782 2.782 0 01-1.236-.289 2.789 2.789 0 002.5 1.553h25.7a2.79 2.79 0 002.79-2.79v-21.61a2.789 2.789 0 00-1.554-2.501z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-288.172 -612.737)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M314.981 1024.529h-25.7a2.789 2.789 0 01-2.79-2.79v-21.61a2.789 2.789 0 012.79-2.79h25.7a2.79 2.79 0 012.79 2.79v21.61a2.79 2.79 0 01-2.79 2.79z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-286.49 -923.85)"
            fill="#bed1f9"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M317.9 999.31a2.793 2.793 0 01.288 1.238v21.609a2.79 2.79 0 01-2.79 2.79H289.7a2.765 2.765 0 01-1.236-.289 2.79 2.79 0 002.5 1.553h25.7a2.789 2.789 0 002.79-2.79v-21.61a2.789 2.789 0 00-1.554-2.501z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-288.172 -925.532)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M694.5 521.651h29.73a2.98 2.98 0 002.98-2.98v-21.23a2.98 2.98 0 00-2.98-2.981H694.5a2.981 2.981 0 00-2.981 2.981v21.23a2.98 2.98 0 002.981 2.98z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-632.329 -494.46)"
            fill="#bed1f9"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M693.293 496.44a2.5 2.5 0 00-.329 1.236v21.61a3.006 3.006 0 003.183 2.791h29.326a3.551 3.551 0 001.41-.289 3.251 3.251 0 01-2.854 1.553H694.7a3.007 3.007 0 01-3.184-2.79V498.94a2.783 2.783 0 011.777-2.5z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-632.329 -496.151)"
            fill="#4951ec"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M668.841 1217.99h29.731a2.98 2.98 0 012.98 2.98v21.23a2.979 2.979 0 01-2.98 2.98h-29.731a2.979 2.979 0 01-2.981-2.98v-21.23a2.98 2.98 0 012.981-2.98z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-610.419 -1112.254)"
            fill="#bed1f9"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M353.186 681.392a.923.923 0 11-.924-.922.924.924 0 01.924.922z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-341.863 -653.287)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M428.02 665.649a.58.58 0 11-.58-.579.58.58 0 01.58.579z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-406.346 -640.137)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M342.365 686.932a8.047 8.047 0 01-5.98-13.429l.2-.225.149.263a1.143 1.143 0 00.368.393l.21.139-.168.188a6.971 6.971 0 1012.166 5.176 2.888 2.888 0 01-2.327-2.831v-5.121l.624-.95.187.237a.812.812 0 00.419.275l.291.079-.446.68v4.8a1.811 1.811 0 003.621 0v-4.783l-.514-.694.286-.095a.812.812 0 00.4-.3l.174-.247.725.979v5.138a2.883 2.883 0 01-2.367 2.838 8.032 8.032 0 01-8.018 7.49z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-327.33 -644.765)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M447.06 665.649a.58.58 0 11-.58-.579.58.58 0 01.58.579z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-422.604 -640.137)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M372.542 704.032h-2.182v-2.182h-2.408v2.182h-2.182v2.408h2.182v2.182h2.408v-2.182h2.182z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-354.184 -671.542)"
            fill="#7c9af2"
          />
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M730.669 559.343h-.7l-1.444-1.992-1.09 4.492-.84-7.794-2.256 5.078-.991-1.8-1.264 2.268-1.721-2.106-.776 3.833-.726-6.589-2.477 4.473h-5.954a.271.271 0 000 .542h6.537l1.35-2.441 1.032 9.337 1.5-7.417 1.381 1.689 1.115-2 1.08 1.961 1.673-3.766 1.023 9.487 1.8-7.436.523.721h1.583a6.07 6.07 0 01-.358-.54z"
              transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(61.915 8.708) translate(-710.16 -554.05)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M854.4 557.842a3.175 3.175 0 012.753-1.282 2.758 2.758 0 012.753 2.848c0 1.776-1.531 3.874-5.506 5.7-3.974-1.825-5.505-3.924-5.505-5.7a2.758 2.758 0 012.753-2.848 3.172 3.172 0 012.752 1.282z"
              transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(82.188 9.075) translate(-848.89 -556.56)"
              fill="#fa7167"
            />
          </g>
          <path
            data-name="&lt;Path&gt;"
            d="M741.707 1267.955l-14.165-1.813a1.642 1.642 0 01-1.42-1.839l.959-7.488a1.644 1.644 0 011.838-1.422l14.164 1.813a1.644 1.644 0 011.422 1.839l-.959 7.49a1.642 1.642 0 01-1.839 1.42z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-661.862 -1144.18)"
            fill="#fff"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M725.448 1267.647l-.386-.872a.7.7 0 00-.639-.415h-6.537a.7.7 0 00-.7.7v4.438h.012v8.366a.7.7 0 00.7.7h19.283a.7.7 0 00.7-.7v-11.1a.7.7 0 00-.7-.7h-11.094a.7.7 0 01-.639-.417z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-654.248 -1153.555)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M771.795 1299.212a3.852 3.852 0 11-3.852-3.852 3.852 3.852 0 013.852 3.852z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-694.294 -1178.317)"
            fill="#dde8fe"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M775.913 1303.225h-1.935v-1.935h-2.135v1.935h-1.933v2.134h1.933v1.935h2.135v-1.935h1.935z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-699.264 -1183.381)"
            fill="#fa7167"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M369.99 1050.3a1.915 1.915 0 101.914-1.916 1.915 1.915 0 00-1.914 1.916z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-357.787 -967.431)"
            fill="#fa7167"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M403.05 1081.46h2.774v-2.67h-2.774z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-386.016 -993.397)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M405.85 1098.871h1.95v-.751h-1.95z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-388.407 -1009.902)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M398.028 1030.107a2.9 2.9 0 00-.5-1.631v-1.841a.8.8 0 00.8-.8v-1.463h2.782v1.463a.8.8 0 00.8.8v4.738a.749.749 0 01-.75.748h-2.889a.748.748 0 01-.694-.468 2.9 2.9 0 00.451-1.546z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-381.303 -946.93)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M398.46 1018.632h4.115v-.982h-4.115z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-382.097 -941.192)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M351.26 1061.72a2.85 2.85 0 00-.013.279 2.926 2.926 0 002.308 2.856 2.525 2.525 0 00-.912 1.179 3.372 3.372 0 00.222 2.623 5.43 5.43 0 002.185 2.265l-.346 1.219c-4.793-1.36-6.828-6.677-3.444-10.421z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-340.363 -978.821)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M369.37 1127.1h4.012v-2.692h-4.012z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-357.258 -1032.35)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M346.47 1144.265h14.887v-.443a.992.992 0 00-.992-.992h-12.9a.992.992 0 00-.992.992z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-337.705 -1048.078)"
            fill="#7c9af2"
          />
          <path
            data-name="&lt;Path&gt;"
            d="M386.49 1110.946h7.659v-1.346h-7.659z"
            transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(-371.876 -1019.704)"
            fill="#fff"
          />
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M667.633 1244.891a2.5 2.5 0 01-.329-1.236v-21.611a3.006 3.006 0 013.183-2.79h29.326a3.549 3.549 0 011.41.289 3.251 3.251 0 00-2.854-1.553h-29.325a3.007 3.007 0 00-3.184 2.79v21.611a2.783 2.783 0 001.773 2.5z"
              transform="translate(-118.47 -390.925) translate(143.025 406.055) translate(55.441 105.736) translate(-665.86 -1217.99)"
              fill="#4951ec"
            />
          </g>
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1337.364 882.05q-1.675 12.14-.14 31.421c.253 3.161 4.719.9 9.427 4.447 7.848 5.908 13.318 13.883 14.713 17.051 3.182-1.435 3.162-15.763 1.421-21.452q-1.895-3.782-25.421-31.467z"
            transform="translate(-118.47 -390.925) translate(296.47 462.697) translate(-1336.49 -882.05)"
            fill="#dde8fe"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1331.013 994.961l-30.358-3.671-19.016 36.231h24.62z"
            transform="translate(-118.47 -390.925) translate(288.455 478.661) translate(-1281.64 -991.29)"
            fill="#0b0754"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1414.2 1027.521l24.753-32.56-30.357-3.671-.542 1.033c4.747 1.242 13.928 4.155 15.292 8.371 1.455 4.5-9.142 20.291-13.734 26.827z"
            transform="translate(-118.47 -390.925) translate(306.928 478.661) translate(-1408.05 -991.29)"
            fill="#0b0754"
            opacity={0.439}
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1291.06 980.01l-19.35 37.232 1.451.647 19.016-36.231 30.357 3.671-1.849-1.45z"
            transform="translate(-118.47 -390.925) translate(287.004 477.013) translate(-1271.71 -980.01)"
            fill="#4951ec"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <path
            data-name="&lt;Path&gt;"
            d="M1360.637 1149.662c.552-.441 5.175 2.43 7.83 4.147l.016-.108c-2.5-1.853-6.873-4.066-5.872-4.7.513-.326 11.492 4.1 11.494 4.1 1.156.525 1.208.574 2.4 1.1-.284-.688-3.157-5.365-1.217-5.135l6.412 8.385c1.087 1.784 1.049 2.864.779 3.8-.332 1.144-1.939 4.215-4.561 4.831-2.524.595-9.366-3.271-10.437-4.27-1.15-.991-8.995-7.848-7.742-9.758q6.541 6.383 7.235 5.593c.039-.183-6.467-4.5-6.977-6.192-.365-1.208 5.325 2.476 7.818 4.322-2.231-1.842-7.558-5.811-7.178-6.115z"
            transform="translate(-118.47 -390.925) translate(299.849 501.706) translate(-1359.606 -1148.983)"
            fill="#fb9390"
          />
        </g>
        <g data-name="&lt;Group&gt;">
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M387.254 1294.854h-20.135a7.968 7.968 0 01-7.969-7.969v-51.157a7.968 7.968 0 017.969-7.968h20.135a7.968 7.968 0 017.967 7.968v51.157a7.968 7.968 0 01-7.967 7.969z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(-359.15 -1227.76)"
              fill="#4951ec"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M545.474 1227.76h-1.024a7.969 7.969 0 017.969 7.968v51.157a7.969 7.969 0 01-7.969 7.969h1.024a7.968 7.968 0 007.967-7.969v-51.157a7.968 7.968 0 00-7.967-7.968z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(27.08) translate(-544.45 -1227.76)"
              fill="#4951ec"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M373.1 1299.806a6.953 6.953 0 01-6.945-6.944V1241.7a6.953 6.953 0 016.945-6.945h20.14a6.953 6.953 0 016.945 6.945v51.157a6.953 6.953 0 01-6.945 6.944z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(1.024 1.023) translate(-366.16 -1234.76)"
              fill="#bed1f9"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M465.953 1254.808h-6.779a.374.374 0 010-.748h6.779a.374.374 0 010 .748z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(14.563 3.843) translate(-458.8 -1254.06)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M462.407 1271.42h-8.156a.41.41 0 110-.82h8.156a.41.41 0 110 .82z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(13.838 6.261) translate(-453.84 -1270.6)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M434.575 1270.113a.563.563 0 11-.563-.563.563.563 0 01.563.563z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(10.858 6.107) translate(-433.45 -1269.55)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M467.694 1631.972a3.072 3.072 0 11-3.072-3.072 3.072 3.072 0 013.072 3.072z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(14.965 58.622) translate(-461.55 -1628.9)"
              fill="#92b5f9"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M464.234 1631.972a3.072 3.072 0 11-3.072-3.072 3.071 3.071 0 013.072 3.072z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(14.459 58.622) translate(-458.09 -1628.9)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M407.611 1355.845h-26.836a1.635 1.635 0 01-1.635-1.634v-41.4a1.635 1.635 0 011.635-1.635h26.835a1.635 1.635 0 011.635 1.635v41.4a1.635 1.635 0 01-1.634 1.634z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(2.921 12.191) translate(-379.14 -1311.18)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M383.81 1358.828v-41.272a.9.9 0 01.9-.9h26.949a.9.9 0 01.9.9v41.272a.9.9 0 01-.9.9h-26.953a.9.9 0 01-.896-.9z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(3.604 12.992) translate(-383.81 -1316.66)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M411.724 1316.66h-27.087a.907.907 0 00-.827.969v6.234h28.741v-6.234a.907.907 0 00-.827-.969z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(3.604 12.992) translate(-383.81 -1316.66)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M446.088 1376.119H429.75v-1.1h16.338z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(10.317 21.52) translate(-429.75 -1375.02)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M403.4 1372.675l1.543 1.045v-2.09z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(6.467 21.025) translate(-403.4 -1371.63)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M551.155 1372.675l-1.545 1.045v-2.09z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(27.834 21.025) translate(-549.61 -1371.63)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M398.316 1332.621h-7.1a1.33 1.33 0 01-1.33-1.33v-.7a1.329 1.329 0 011.33-1.33h7.1a1.329 1.329 0 011.33 1.33v.7a1.33 1.33 0 01-1.33 1.33z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 14.833) translate(-389.89 -1329.26)"
              fill="#4951ec"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M552 1332.621h-1.727a.683.683 0 01-.684-.684v-1.993a.683.683 0 01.684-.684H552a.684.684 0 01.684.684v1.993a.684.684 0 01-.684.684z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(27.831 14.833) translate(-549.59 -1329.26)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M558.975 1335.2h-.5v-2.182h.5z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(29.13 15.383) translate(-558.48 -1333.02)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M555.67 1338.5v.58h-1.86v-.58z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(28.447 16.183) translate(-553.81 -1338.5)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M396.8 1440.379h-3.18v-27.489h3.18z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(5.037 27.055) translate(-393.62 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M422.909 1440.379h-3.179v-27.489h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(8.853 27.055) translate(-419.73 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M449.209 1440.379h-3.179v-27.489h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(12.697 27.055) translate(-446.03 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M475.519 1440.379h-3.179v-27.489h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(16.541 27.055) translate(-472.34 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M501.819 1440.379h-3.179v-27.489h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(20.385 27.055) translate(-498.64 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M528.129 1440.379h-3.179v-27.489h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(24.23 27.055) translate(-524.95 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M554.43 1440.379h-3.18v-27.489h3.18z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(28.073 27.055) translate(-551.25 -1412.89)"
              fill="#dde8fe"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M396.8 1391.32h-3.18v2.087h3.18z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(5.037 23.902) translate(-393.62 -1391.32)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M422.909 1391.32h-3.179v2.087h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(8.853 23.902) translate(-419.73 -1391.32)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M449.209 1391.32h-3.179v2.087h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(12.697 23.902) translate(-446.03 -1391.32)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M475.519 1391.32h-3.179v2.087h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(16.541 23.902) translate(-472.34 -1391.32)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M501.819 1391.32h-3.179v2.087h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(20.385 23.902) translate(-498.64 -1391.32)"
              fill="#7c9af2"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M528.129 1391.32h-3.179v2.087h3.179z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(24.23 23.902) translate(-524.95 -1391.32)"
              fill="#fa7167"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M554.43 1391.32h-3.18v2.087h3.18z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(28.073 23.902) translate(-551.25 -1391.32)"
              fill="#fa7167"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.974 1435.252H389.89v-.682h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 30.223) translate(-389.89 -1434.57)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.974 1463.323H389.89v-.682h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 34.325) translate(-389.89 -1462.64)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.974 1491.393H389.89v-.683h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 38.427) translate(-389.89 -1490.71)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.974 1519.463H389.89v-.683h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 42.529) translate(-389.89 -1518.78)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.974 1547.533H389.89v-.683h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.492 46.631) translate(-389.89 -1546.85)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M416.564 1575.6H389.48v-.682h27.084z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(4.432 50.734) translate(-389.48 -1574.92)"
              fill="#fff"
            />
          </g>
          <g data-name="&lt;Group&gt;">
            <path
              data-name="&lt;Path&gt;"
              d="M464.429 1449.263l-2.609-1.122 3.269 4 2.79-6.261z"
              transform="translate(-118.47 -390.925) translate(153.643 513.219) translate(15.004 31.876) translate(-461.82 -1445.88)"
              fill="#fa7167"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
